import type { QueryClient } from '@tanstack/react-query';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { ImpersonationBanner } from '../components/ImpersonationBanner.js';
import type { trpc } from '../lib/trpc.js';

export interface RouterContext {
  queryClient: QueryClient;
  trpc: typeof trpc;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <ImpersonationBanner />
      <Outlet />
    </div>
  );
}
